import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Seo from "../components/Seo";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { PhotoGrid, thumb } from "../components/PhotoGrid";
import { api } from "../lib/api";

export function CollectionsIndex() {
  const [cols, setCols] = useState([]);
  useEffect(() => { api.get("/photos/collections").then((r) => setCols(r.data)).catch(() => {}); }, []);
  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14" data-testid="collections-index">
      <Seo title="Photography Collections — CaminoSapiens" description="Browse our photography by collection — routes, regions and journeys on foot." />
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Photography", to: "/photography" }, { label: "Collections" }]} />
      <div className="max-w-2xl mb-12">
        <p className="overline mb-4">Photography</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-tight">Collections</h1>
      </div>
      {cols.length === 0 && <p className="text-[#4A4947]">No collections yet. Assign photographs to collections in the studio.</p>}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {cols.map((c) => (
          <Link key={c.name} to={`/photography/collections/${encodeURIComponent(c.name)}`} data-testid={`collection-card-${c.name}`} className="group block">
            <div className="aspect-[4/3] overflow-hidden border border-[#E4E1DB] bg-[#F0EFEA]">
              {c.cover && <img src={thumb(c.cover, 800)} alt={c.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />}
            </div>
            <div className="pt-3 flex items-baseline justify-between">
              <p className="font-display text-xl">{c.name}</p>
              <p className="text-sm text-[#9a9793]">{c.count}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export function CollectionGallery() {
  const { name } = useParams();
  const collection = decodeURIComponent(name || "");
  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14" data-testid="collection-gallery">
      <Seo title={`${collection} — Photography — CaminoSapiens`} description={`Photographs from the ${collection} collection.`} />
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Photography", to: "/photography" }, { label: "Collections", to: "/photography/collections" }, { label: collection }]} />
      <div className="max-w-2xl mb-12">
        <p className="overline mb-4">Collection</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-tight">{collection}</h1>
      </div>
      <PhotoGrid filters={{ collection }} emptyText="No photographs in this collection yet." />
    </div>
  );
}
